module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('Chart2', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				chartBlockSelector: '.chart-conainer',
				chartOptions: {
					title: null,
					legend: {
						enabled: false
					},
					chart: {
						type: 'area',
						height: 220,
					},
					tooltip: {
						formatter: function (tip) {
							return  this.series.name + '<span style="color: ' + this.series.color + '"></span> <br />$ ' + this.point.y;
						}
					},
					xAxis: {
						type: 'datetime',
						labels: {
							// enabled: false,
							formatter: function() {
								// clean, unformatted number for year
								return fox.utils.dateFormat('%e %b %Y', this.value);
							}
						}
					},
					yAxis: {
						title: '',
						labels: {
							//enabled: false/*,
							formatter: function() {
								return this.value;
							}
						}
					},
					plotOptions: {
						area: {
							fillOpacity: '0.5',
							pointStart: 0,
							marker: {
								enabled: false,
								symbol: 'circle',
								radius: 2,
								states: {
									hover: {
										enabled: true,
										radius: 5
									}
								}
							},
							lineWidth: 0
						}
					},
					colors: [
						'#d7d7d7',
						'#f9db62',
						'#0692f0'
					],

					//data here
					/*series: [{
						name: 'Joins',
						data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6]
					}, {
						name: 'Rebills',
						data: [-0.2, 0.8, 5.7, 11.3, 17.0, 22.0, 24.8, 24.1, 20.1, 14.1, 8.6, 2.5]
					}, {
						name: 'Refunds',
						data: [-0.9, 0.6, 3.5, 8.4, 13.5, 17.0, 18.6, 17.9, 14.3, 9.0, 3.9, 1.0]
					}]*/
				},

				handleDom: {
					visibiltySwitcher: {
						target: '.switcher',
						event: 'click',
						callback: 'chartVisibilitySwitch'
					},
					visibiltySwitcher2: {
						target: 'input.toggle-chart',
						event: 'change',
						callback: 'chartVisibilitySwitch'
					}					
				},

				'hooks.onAddedToDom': fox.bind(function() {
					this.renderChart();
				}, this)

			});

			this.callParent('configure', arguments);
		},

		renderChart: function () {
			if (!this.element || !this.element.length) return;

			var container = $(this.getOption('chartBlockSelector'), this.element[0]);
			
			var timezoneOffset = this.getOption('timezoneOffset');
			var useUTC = !!this.getOption('useUTC');

			window.Highcharts.setOptions({
				global: {
					timezoneOffset: timezoneOffset !== undefined ? timezoneOffset : fox.utils.getCurrentTimezone() * 60,
					useUTC: useUTC
				}
			});

			this._chart = $(container).highcharts(this.getOption('chartOptions'));
			this._chartIsRendered = true;

			$(this.dom('tspan')).parent().find(':contains(Highcharts.com)').hide();
			$(this.dom('text')).parent().find(':contains(Highcharts.com)').hide();
		},

		chartVisibilitySwitch: function (el) {
			var wel = fox.dom.wrap(el);
			var chartId = wel.attr('chart-id');
			var isEnabled = $(el).is('input[type=checkbox]') ? $(el).prop('checked') : wel.hasClass('active');

			if (!chartId) return;

			var chartItem = this.getSeries(chartId);

			if (chartItem) {
				chartItem.setVisible(isEnabled);
				wel[isEnabled ? 'removeClass' : 'addClass']('active');
			}
		},

		toggleVisibleSeries: function(serieIds, state) {
			if (serieIds === undefined) return;

			if (!fox.isArray(serieIds)) {
				serieIds = [serieIds];
			}

			var action = state === true ? 'show' : 'hide';

			serieIds.forEach(function(serieId) {
				var serie = this.getSeries(serieId);
				
				if (this.getSeries(serieId)) {
					serie[action]();
				}
			}, this);
		},

		setData: function (data) {
			this.setOption('chartOptions.series', data);
			//this.renderChart();
			return this;
		},

		updateSeriesData: function (id, data) {
			var chartItem = this.getSeries(id);

			if (!chartItem) {
				return;
			}
			// data => object of data like type, color, etc
			chartItem.update(data);
			this.dispatchEvent('chartUpdated', id);
		},

		setSeriesData: function (id, data) {
			var chartItem = this.getSeries(id);

			if (!chartItem) {
				return;
			}
			// data => array of chart values
			this.data = data;
			chartItem.setData(data);
			this.dispatchEvent('chartSetted', id);
		},

		addSeries: function (data) {
			this.getHightChartObject().addSeries(data);

			return this;
		},

		getSeries: function (id) {
			return this.getHightChartObject().get(id);
		},

		_setData: function (data) {
			//this.data = data;
			//this.setOption('chartOptions.series', data);
			//this.renderChart();
			return this;
		},
		
		getData: function () {
			return this.data;
		},

		/*getData: function () {
			return this.getOption('chartOptions.series');
		},*/

		getSeriesData: function (id) {
			return this.getSeries(id).data;
		},

		getHightChartObject: function () {
			return this._chart.highcharts();
		},

		hideChart: function () {
			fox.dom.addClass('hide', this.element[0]);
		},

		showChart: function () {
			fox.dom.removeClass('hide', this.element[0]);
		}

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/chart2.js
// module id = 297
// module chunks = 2